import React from 'react';
import { VoucherFormSection } from '../../Section';
import { AllowedCountries } from '../AllowedCountries';
import { LinesAutocomplete } from '../Lines';
interface VoucherFormCountriesAndLinesProps {
  template?: {
    allowedCountries?: boolean;
  };
}

const VoucherFormCountriesAndLines: React.FC<VoucherFormCountriesAndLinesProps> = ({
  template,
}) => {
  return (
    <VoucherFormSection
      title='Countries and lines'
      subtitle='Where users are allowed to travel with the voucher.'
      inputs={
        <>
          <LinesAutocomplete label='Allowed lines' ruleType='line_whitelist' />
          <LinesAutocomplete label='Forbidden lines' ruleType='line_blacklist' />
          {template?.allowedCountries && <AllowedCountries />}
        </>
      }
    />
  );
};

export default VoucherFormCountriesAndLines;
